import { ACCENT_VALUES, accentMessages } from '@/features/shadowHeidi/research-options';
import { useQueryInputSupportedLanguages } from '@/hooks/query/useQuerySupportedLanguages';
import {
  type PatientContextFieldsHost,
  type PatientContextPhoneInputProps,
} from '@heidi/patients';
import { isPatientContextAutoExtractEnabled as IS_PATIENT_CONTEXT_AUTO_EXTRACT_ENABLED } from '@heidi/patients/flags';
import { useTranslations } from '@heidi/runtime/i18n';
import { getLocalizedLanguageName } from '@heidi/session/data';
import { PhoneInput } from '@heidi/snowflake-ui/phone-input';
import { useCallback } from 'react';

/** Binds the form-field surface to the app implementations it renders. */
export function usePatientContextFieldsHost(): PatientContextFieldsHost {
  // Language display names live in the i18next catalog, so `t` is bound here
  // rather than in the package. Keyed on `t` so a language change rebuilds the
  // labels the surface memoizes on this identity.
  const { t } = useTranslations();
  const getLanguageName = useCallback<PatientContextFieldsHost['getLanguageName']>(
    (code, options) => getLocalizedLanguageName(code, t, options),
    [t]
  );

  return {
    PhoneInput,
    isAutoExtractEnabled: IS_PATIENT_CONTEXT_AUTO_EXTRACT_ENABLED,
    accentValues: ACCENT_VALUES,
    accentMessages,
    useSupportedLanguages: useQueryInputSupportedLanguages,
    getLanguageName,
  };
}

export type { PatientContextPhoneInputProps };
